<template>
  <div class="van-tabs-content item3">
    <img class="img-box" src="@/assets/img/hotel_demo.png" alt="">
    <div class="hotel-info item1">
      <img src="~@/assets/img/ic_hotel.png" alt="" />
      {{ accommodationInfo.hotel }}
    </div>
    <div class="hotel-info item2">
      <img src="~@/assets/img/address_icon.png" alt="" />
      {{ accommodationInfo.address }}
    </div>
    <div class="hotel-info-card">
      <div class="hotel-info-type">
        <div>{{ $t('personal.Accommodation.checkin') }}</div>
        <div>{{ $t('personal.Accommodation.leave') }}</div>
      </div>
      <div class="hotel-info-day">
        <div>{{
          language === 'zh'
          ? checkDate(accommodationInfo.checkinTime)
          : checkDateEn(accommodationInfo.checkinTime)
        }}</div>
        <div>{{
          language === 'zh'
          ? checkDate(accommodationInfo.leaveTime)
          : checkDateEn(accommodationInfo.leaveTime)
        }}</div>
      </div>
      <div class="hotel-info-time">
        <div>{{ checkTime(accommodationInfo.checkinTime) }}</div>
        <div>{{ checkTime(accommodationInfo.leaveTime) }}</div>
      </div>
      <img class="hotel-info-img" src="~@/assets/img/hotel_img.png" />
    </div>
  </div>
</template>

<script>
import { getAccommodationInfo } from '@/api/guest'
export default {
  name: "AccommodationInfo",
  data() {
    return {
      language: 'zh',
      accommodationInfo: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.language = this.$i18n.locale
      this.getAccommodationInfo()
    },
    getAccommodationInfo() {
      getAccommodationInfo().then(res => {
        this.accommodationInfo = res.data
      })
    },
    checkDate(datetime) {
      if (!datetime) {
        return ''
      }
      const month = datetime.substring(5, 7)
      const day = datetime.substring(8, 10)
      return month + '月' + day + '日'
    },
    checkDateEn(datetime) {
      if (!datetime) {
        return ''
      }
      const month = datetime.substring(5, 7)
      const day = datetime.substring(8, 10)
      return month + '.' + day
    },
    checkTime(datetime) {
      if (!datetime) {
        return ''
      }
      return datetime.substring(11, 16)
    },
  }
};
</script>

<style lang="scss" scoped>
.van-tabs-content {
  position: relative;
  margin: 15px 0 0;
  padding: 19px 15px 27px;
  background: linear-gradient(358deg, rgba(12, 24, 130, 0.6) 0%, #253196 100%);
  border-radius: 6px;
  border: 1px solid;
  border-image: linear-gradient(360deg,
      rgba(69, 132, 199, 0.2),
      rgba(71, 137, 199, 0.3)) 1 1;

  .img-box {
    width: 315px;
    height: 133px;
  }

  .hotel-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 15px 0 0;

    &.item1 {
      img {
        margin-right: 6px;
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      font-size: 16px;
      font-family: SourceHanSansSC-Medium,
      SourceHanSansSC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
    }

    &.item2 {
      margin: 8px 0 0;

      img {
        margin-right: 6px;
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      font-size: 13px;
      font-family: SourceHanSansSC-Light,
      SourceHanSansSC;
      font-weight: 300;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .hotel-info-card {
    position: relative;
    margin: 19px 0 0;
    padding: 10px 0 0;
    width: 320px;
    height: 138px;
    background: url("~@/assets/img/hotel_info_bg.png") center no-repeat;
    background-size: contain;
    box-sizing: border-box;

    .hotel-info-type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-left: 44px;
      padding-right: 51px;
      font-size: 16px;
      font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 500;
      color: rgba($color: #fff, $alpha: 0.7);
      line-height: 24px;
    }

    .hotel-info-day {
      margin: 28px 0 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-left: 25px;
      padding-right: 33px;
      font-size: 16px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #ffffff;
      line-height: 16px;
    }

    .hotel-info-time {
      margin: 16px 0 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-left: 41px;
      padding-right: 49px;
      font-size: 14px;
      font-family: Helvetica-Bold, Helvetica;
      color: #ffffff;
      line-height: 17px;
    }

    .hotel-info-img {
      position: absolute;
      left: 98px;
      bottom: 46px;
      width: 117px;
      height: 20px;
      object-fit: contain;
    }
  }
}
</style>
